/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
theme.nwCollection = function () {
  const toggleButtons = document.querySelectorAll(".view-toggle button");
  const collectionTable = document.querySelector(".collection__table-view");
  const collectionCards = document.querySelector(".collection__cards");

  //make sure view remains after pagination click
  function ensureViewOnPaginationChangeByLocalStorage() {
    if (localStorage.getItem("collection-display-type") == "list") {
      if (toggleButtons.length !== 0) {
        document
          .querySelector('button[data-view="grid"]')
          .classList.remove("active");
        document
          .querySelector('button[data-view="list"]')
          .classList.add("active");
        collectionCards.style.display = "none";
        collectionTable.style.display = "table";
      }
    } else {
      if (toggleButtons.length !== 0) {
        document
          .querySelector('button[data-view="list"]')
          .classList.remove("active");
        document
          .querySelector('button[data-view="grid"]')
          .classList.add("active");
        collectionCards.style.display = "block";
        collectionTable.style.display = "none";
      }
    }
  }

  // init toggle Buttons
  function initToggleButtonsForTableGridSwitch() {
    toggleButtons.forEach((button) => {
      button.addEventListener("click", function () {
        toggleButtons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");

        if (this.dataset.view === "list") {
          collectionCards.style.display = "none";
          collectionTable.style.display = "table";
          localStorage.setItem("collection-display-type", "list");
        } else {
          collectionCards.style.display = "block";
          collectionTable.style.display = "none";
          localStorage.setItem("collection-display-type", "grid");
        }
        //makes the grid-products appear
        window.dispatchEvent(new Event("resize"));
      });
    });
  }

  initToggleButtonsForTableGridSwitch();
  if (document.querySelector(".collection__table-view") !== null) {
    ensureViewOnPaginationChangeByLocalStorage();
  }
};

theme.nwCollection();

function checkAnnouncementHidden() {
  if ($('.announcement').is('[hidden]')) {
    $('body').addClass('announcement-hidden');
  } else {
    $('body').removeClass('announcement-hidden');
  }
}


$(document).ready(function () { 

    checkAnnouncementHidden();

  // Watch for changes to the 'hidden' attribute
  const target = document.querySelector('.announcement');
  if (target) {
    const observer = new MutationObserver(checkAnnouncementHidden);
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['hidden']
    });
  }
  
  $(".product-accordion .accordion-item").on("click", function () {
    $(".product-accordion .accordion-item .collapse-block").slideUp();
    $(".product-accordion .accordion-item").removeClass("active");

    const answerBlock = $(this).find(".collapse-block");

    if (!answerBlock.is(":visible")) {
      answerBlock.slideDown();
      $(this).addClass("active");
    }
  });

  if ($(".product-accordion .accordion-item").length > 0) {
    $(".product-accordion .accordion-item").first().trigger("click");
  }
});

const header = document.querySelector("header");
const announcement = document.querySelector(".announcement__container"); // ✅ Updated selector
const body = document.body;
const actionsElement = document.querySelector(".collection-main__actions");
const actionsElement2 = document.querySelector(".view-toggle");
const actionsElement3 = document.querySelector(".filter-part");

function updateTopPosition() {
  if (!header) return;

  const headerHeight = header.offsetHeight || 0;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;

  const totalHeight = headerHeight + announcementHeight;
  const isMobile = window.innerWidth <= 979;

  if (body.classList.contains("header-down")) {
    if (actionsElement2) actionsElement2.style.top = `${totalHeight - 1}px`;
    if (actionsElement3) actionsElement3.style.top = `${totalHeight}px`;

    if (isMobile) {
      if (actionsElement) actionsElement.style.top = `${totalHeight - 1}px`;
      if (actionsElement2) actionsElement2.style.top = `${totalHeight + 50}px`;
    } else {
      if (actionsElement) actionsElement.style.top = "";
    }
  } else {
    if (actionsElement) actionsElement.style.top = "";
    if (actionsElement2) actionsElement2.style.top = "";
    if (actionsElement3) actionsElement3.style.top = "";
  }
}

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      updateTopPosition();
    }
  }
});

if (header) {
  observer.observe(body, { attributes: true });
  window.addEventListener("resize", updateTopPosition);
  window.addEventListener("load", updateTopPosition); // ✅ Ensures dynamic elements like announcement are ready
}

